import React from "react";
import OwTranslate from "../OwTranslate/OwTranslate";
import IAction from "../../../models/IAction";
import OwButton from "../OwButton/OwButton";
import * as _ from "lodash-es";

type Props = {
    title: string;
    actions: IAction[];
};

export const FieldsetActions = (props: Props) => {
    const getActiveDisabled = (action: IAction): { active: boolean; disabled: boolean } => {
        let isActive = false;
        let disabled = false;

        if (action.disabledFn && _.isFunction(action.disabledFn)) {
            disabled = action.disabledFn(null);
        }

        if (action.isActive) {
            if (_.isFunction(action.isActive)) {
                isActive = action.isActive(action.name);

                if (isActive) {
                    disabled = true;
                }
            } else if (!_.isFunction(action.isActive) && action.isActive) {
                isActive = disabled = true;
            }
        }

        return {
            active: isActive,
            disabled,
        };
    };

    const getBtnClass = (action: IAction): string => {
        let btnClass = "";

        if (action.btnClass) {
            if (_.isFunction(action.btnClass)) {
                // @ts-expect-error
                btnClass = action.btnClass();
            } else {
                // @ts-expect-error
                btnClass = action.btnClass;
            }
        }

        return btnClass;
    };

    return (
        <div className={"FieldsetActions"}>
            <fieldset className={"fieldset border p-2"}>
                <legend className={"w-auto text-small"}>
                    <OwTranslate defaultMessage={props.title} id={props.title} />
                </legend>
                <div className={"d-flex"}>
                    {props.actions.map((action: IAction, index: number) => {
                        const { active, disabled } = getActiveDisabled(action);
                        const btnClass = getBtnClass(action);

                        return (
                            <div key={index} className={"d-flex justify-content-start"}>
                                <OwButton
                                    leftIconClass={action.leftIconClass}
                                    title={action.name}
                                    fn={action.fn}
                                    active={active}
                                    disabled={disabled}
                                    className={btnClass}
                                />
                            </div>
                        );
                    })}
                </div>
            </fieldset>
        </div>
    );
};
